// extracted by mini-css-extract-plugin
export default {"header":"drawer_header__Ke1qh","content":"drawer_content__E-Xbo","slideIn":"drawer_slideIn__FNDdU"};